import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnDetailsComponent } from './return-details.component';
import {PageTitle} from "../../store-front/misc/page-title/page-title.component";
import {AuthGuard, CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {FormModule} from "@spartacus/organization/administration/components";
import {RouterModule} from "@angular/router";
import {CustomBannerModule} from "../../store-front/misc/cms-components/banner/banner.module";
import {CustomCartSharedModule} from "../../cart/base/components/cart-shared";
import {LocalLoaderComponent} from "../../../../components/loader/local-loader/local-loader.component";

@NgModule({
  declarations: [
    ReturnDetailsComponent
  ],
    imports: [
        CommonModule,
        PageTitle,
        I18nModule,
        FormModule,
        RouterModule,
        CustomBannerModule,
        CustomCartSharedModule,
        LocalLoaderComponent,
    ],
  providers: [
    provideConfig(<CmsConfig >{
      cmsComponents: {
        ReturnDetailsComponent: {
          component: ReturnDetailsComponent,
          guards: [AuthGuard],
        }
      },
    })
  ]

})
export class ReturnDetailsModule { }
